'use strict';

exports.__esModule = true;

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

var _actions = require('../actions');

var _actions2 = _interopRequireDefault(_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var onRejection = function onRejection(store, next, action, meta) {
  return function (reason) {
    return next(_actions2.default.for(action.method).reject((0, _merge2.default)(action, {
      reason: reason,
      request: { meta: meta }
    })));
  };
};

exports.default = onRejection;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-redux-fetch/lib/utils/onRejection.js
// module id = 675
// module chunks = 0